import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Mouth_14 = ({ skinColours, lipColours }) => {
  const colour0 = lipColours.base;
  const colour1 = lipColours.base;
  const colour2 = lipColours.shadow;
  const colour3 = '#40332E';
  const colour4 = '#FFFEF0';
  const colour5 = '#F2D5B2';
  const colour6 = '#FFEFDA';
  const colour7 = lipColours.base;
  const colour8 = '#2E201E';

  return (
    <>
      <g>
        <path
          fill={colour0}
          d="M469.3,567.1c-12.8-6.2-126.6-12.6-133.7-9.2c-13,6.2-17.8,24.6-11.1,23.2c15-3.2,42.3,18.2,68.4,18.2
		c29.2,0,60.6-15.7,88.2-15C486.7,584.4,487.3,575.8,469.3,567.1z"
        />
        <path
          fill={colour1}
          d="M396.2,515.4c6.9-0.5,19.8-7.8,24.9-6.6c5.1,1.2,53.7,29.6,65.4,62.2c0,0,3.2,15.2-5.6,11.5
		c-8.8-3.7-80-40.3-92.3-37.2c-12.2,3.1-62.7,37.6-66.4,34.8c-7.1-5.3,28.1-67.1,50.2-70.8C381.8,507.8,387.4,516,396.2,515.4z"
        />
        <path
          fill={colour2}
          d="M486.5,571c-7.3-20.6-29.4-39.4-46-50.9c4.2,20.1-49.1,8.7-42.7-5c-0.6,0.1-1.1,0.2-1.6,0.2
		c-2.5,0.2-4.7-0.4-6.8-1.2c2,6.7-7.8,13.7-16.4,15.3c-11.2,2-21.2,0.4-21.3-5.6c-18,19.6-34.6,52.4-29.5,56.2
		c3.8,2.8,54.2-31.7,66.4-34.8c12.2-3.1,83.5,33.5,92.3,37.2C489.7,586.2,486.5,571,486.5,571z"
        />
        <path
          fill={colour1}
          d="M327.6,579.9c15-3,48.8,17,65.7,16.1c19.6-1.1,62.6-15,84.4-12.9c5.4,0.5,13.2-2.5-4.8-10.7
		c-18-8.2-58.7-24.2-80.5-20.4c-12.2,2.1-37.9,8.6-54.4,16C325.1,573.9,320.9,581.3,327.6,579.9z"
        />
        <path
          fill={colour2}
          d="M474.9,571.4c-12.8-5.9-49.6-20.2-70.1-13.1c24.5,7.8,48.4,17.5,48.4,21.8c0,3.7-39.4,11.1-60.3,11.1
		c-20.8,0-46.7-10.2-46.7-13.8c0-5.8,22-14,35.6-18.3c-12.7-4.5-38.7,4.9-45.8,8.1c-13,5.9-17.6,15-10.9,13.7
		c15-3,51.2,17.4,68,16.4c19.6-1.1,65-15.4,86.8-13.2C485.5,584.8,492.9,579.6,474.9,571.4z"
        />
        <path
          fill={colour0}
          d="M335.3,574c5.3-0.2,44.8-18.2,64.6-16.2c19.8,2,66.7,23,71.2,22.9c2.3-0.1,11.7,0.2,12.5-0.4
		c0.8-0.7,1.6-7.5,1.6-8.6c0-1.1-15.6-34.1-45.6-39.8c-3.5-0.7-28.2,4.7-43.7,3.6c-15.5-1.1-25.1-3.5-29.8-2.4
		c-4.7,1.1-30.9,10.2-38.7,37.4C326.5,573.3,335.3,574,335.3,574z"
        />
        <path
          fill={colour3}
          d="M336,572.7c5.3-0.2,44-16.9,63.8-15c19.8,1.8,66.7,21.5,71.2,21.4c2.3-0.1,7.7,0.3,8.5-0.3
		c0.8-0.6,4.3-7,4.3-8c0-1-14.2-32-44.3-37.3c-3.5-0.6-28,6.8-43.5,5.7c-15.5-1-24.9-4.9-29.6-3.9c-4.7,1-28.3,6.9-36.1,32.2
		C329.5,570.1,336,572.7,336,572.7z"
        />
        <path
          fill={colour4}
          d="M468.9,576.8c3.9-1.1,1.8-22.7-1.6-26.8c-3.4-4.1-21.2-11.9-25.6-13.4c-4.4-1.5-33.1,4.2-45.7,4.2
		c-13.2,0-27.3-4.5-32-3.1c-5.2,1.5-17.1,7.9-18.6,9.8c-1.5,1.9-3.9,21-2.7,21.4c1.2,0.4,32.8-16.9,62.5-12.2
		C433.4,561.4,466.2,577.5,468.9,576.8z"
        />
        <path
          fill={colour5}
          d="M341.2,564.8c4.1-5.2,14.1-11.6,28.7-14.3c0,0-24.6,4.8-25.2,1.6C344.7,552.1,339.4,562.1,341.2,564.8z"
        />
        <path
          fill={colour6}
          d="M471,571.3c-4.3-5.2-28.3-16.5-43.5-19.2c0,0,41.5,7.2,42.1,3.9C469.6,556,472.9,568.6,471,571.3z"
        />
        <path
          fill={colour6}
          d="M470.5,561.7c0.3,6.4-0.3,12.3-2.3,12.9c-2.9,0.8-36.1-15.5-64.6-19.9c-28.6-4.5-59.1,12.5-60.2,12.1
		c-0.9-0.3,0.4-12.7,1.6-18.6c-1.5,3.8-3.5,20.4-2.4,20.8c1.2,0.4,32.9-16.3,62.6-11.5c28.2,4.6,61,20.1,63.7,19.3
		C471.1,576.1,471.4,568.7,470.5,561.7z"
        />
        <path
          fill={colour5}
          d="M348.1,553.2c-4.8-4.6,10.6-8.6,15.8-10.1c4.7-1.4,18.9,3.1,32.2,3.1c12.7,0,41.7-5.7,46.1-4.2
		c4.4,1.5,32.4,9.7,23,14.8c-1.6,0.9,5,3.4,5.6,7.4c-0.5-5.9-1.8-12.1-3.5-14.1c-3.4-4.1-21.2-11.9-25.6-13.4
		c-4.4-1.5-33.1,4.2-45.7,4.2c-13.2,0-27.3-4.5-32-3.1c-5.2,1.5-17.1,7.9-18.6,9.8c-1.3,1.6-3.2,15.5-3,20
		C342.9,561.7,349.2,554.2,348.1,553.2z"
        />
        <path
          fill={colour3}
          d="M342.5,569.7c-0.4-3.2,1.1-10.6,7-13.1c3-1.3,0.8-3-1.7-2.3c-2.5,0.6-3.4-4.5-2.5-7.2c0,0-7,5.5-7.8,12.9
		C336.6,567.4,342.5,569.7,342.5,569.7z"
        />
        <path
          fill={colour3}
          d="M469,577.1c3.9-3.5,2.4-15.2-8.6-16.9c-11.1-1.8-13.2-3.9-13.2-3.9s10.6,3,14.1,2.2c3.4-0.8,9.3,4.9,9-2.8
		c0,0,4.9,5.4,4.7,12.5C474.9,576.2,469,577.1,469,577.1z"
        />
        <path
          fill={colour5}
          d="M425.5,551.9c-2.4,0.2-11-1.1-14.9-1.6c0,0,4.8,0,9.2,0.4C423.2,551,426.8,551.8,425.5,551.9z"
        />
        <path
          fill={colour7}
          d="M407.5,559.9c-17.5-5.8-43.3,6.4-47.5,10.5c-4.2,4.1,15.6,8.3,31.1,6.4C407.3,574.8,425,565.7,407.5,559.9z"
        />
        <path
          fill={colour8}
          d="M471.6,561.8c6.4,1.1,9.5,6.5,9.8,8.5c0.3,2-2.3,6.6-3.5,6.9c-1.3,0.3-4.7-0.6-4.7-0.6
		C470.9,576,475.9,568.3,471.6,561.8z"
        />
        <path
          fill={colour8}
          d="M340.6,569.6c-0.1-4,1.6-12.4,6.8-14c0,0-5.2-1.4-4.9-4.4c0,0-6.7,2.2-9.8,15.5c-0.4,1.8,3.3,3.5,4,3.8
		C338.2,571.3,340.6,569.6,340.6,569.6z"
        />
        <path
          fill={colour7}
          d="M420.7,566.4c1.3-0.2,7.8,2.8,6.6,4.5c-1.2,1.8-9.7,1.2-10.8-0.4C415.3,569.1,419.1,566.7,420.7,566.4z"
        />
        <path
          fill={colour2}
          d="M386,591.2c4.8,0.3,6.3-2,7.2-7.6c0,0-0.5,5.5,4,8.2l-6.5,2.4L386,591.2z"
        />
        <path
          fill={colour0}
          d="M394.1,535.9c4.8,0.1,5.2-2.5,3.6-8.6c0,0,2,6,7.4,8.6l-5.2,2.9L394.1,535.9z"
        />
        <path
          fill={colour2}
          d="M405,590.7c2.6-0.1,3.3-1.4,3.5-4.5c0,0,0,3,2.5,4.2l-3.4,1.6L405,590.7z"
        />
        <path
          fill={colour2}
          d="M362.5,586.2c2.4,0.9,3.6,0,5-2.8c0,0-1.1,2.8,0.7,4.9l-3.7,0.2L362.5,586.2z"
        />
        <path
          fill={colour7}
          d="M419,509.5c-5.1,0.9-10.9,4-6.7,6.3c4.3,2.3,22.3,5.2,21.6,3.1C432.2,514.2,421.7,509,419,509.5z"
        />
        <path
          fill={colour7}
          d="M374.4,509.6c-8.4,0.2-12.4,9.6-12.4,11.9c0,2.2,18.1-2.4,21.1-6.2C385.3,512.5,379.5,509.6,374.4,509.6z"
        />
        <path
          fill={colour0}
          d="M389.4,529c-1.1,2.9-3.7,5.4-5.4,6.1l3.4,0.3C389.5,531.9,389.4,529,389.4,529z"
        />
        <path
          fill={colour0}
          d="M392.2,531.4c-0.4,1.9-1.8,3.7-2.7,4.2l2,0.1C392.5,533.3,392.2,531.4,392.2,531.4z"
        />
        <polygon fill={colour6} points="372.6,557.9 373,552.8 375,557.2 	" />
        <polygon fill={colour5} points="365.2,541.3 365.9,546.3 363,542.5 	" />
        <polygon fill={colour5} points="440.1,538.9 440.6,546.2 441.7,539.5 	" />
      </g>
    </>
  );
};

export default Mouth_14;
